import React from "react";
import "./App.css";
import HomeScreen from "./pages/Home/HomeScreen";
import Landing from "./pages/Landing/Landing";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Profile from "./pages/Profile/Profile";
import Movie from "./pages/Movie/Movie";
import Actor from "./pages/Actor/Actor";
import Movies from "./pages/Movies/Movies";
import TVShows from "./pages/TVShows/TVShows";
import NewPopular from "./pages/NewPopular/NewPopular";
import Anime from "./pages/Anime/Anime";
import CategoryBrowse from "./pages/Browse/CategoryBrowse";

function App() {
	return (
		<div className="app">
			<Router>
				<Routes>
					<Route path="/profile" element={<Profile />} />
					<Route path="/movie/:id" element={<Movie />} />
					<Route path="/actor/:id" element={<Actor />} />
					<Route path="/movies" element={<Movies />} />
					<Route path="/tv-shows" element={<TVShows />} />
					<Route path="/anime" element={<Anime />} />
					<Route path="/browse" element={<CategoryBrowse />} />
						<Route path="/new-popular" element={<NewPopular />} />
					<Route path="/landing" element={<Landing />} />
					<Route path="/" exact element={<HomeScreen />} />
				</Routes>
			</Router>
		</div>
	);
}

export default App;
